import { uuid } from "../../UUID";
import { NidusEntryId } from "../INidusClient";

export function createUniqueNidusEntryId(): NidusEntryId {
    return uuid() as NidusEntryId;
}
